(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/shared/components/wrapper.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/shared/components/wrapper.js');
"use strict";


const Wrapper = _ref => {
  let {
    children,
    onClose,
    show
  } = _ref;
  const {
    useContext
  } = React;
  const {
    game
  } = useContext(svs.eInstant.shared.info.InfoContext);
  const {
    name,
    isInverted
  } = game;
  const {
    Grid
  } = svs.ui.ReactGrid;
  const IconButton = svs.ui.ReactIconButton;
  const Icon = svs.ui.ReactIcon;
  return React.createElement(Grid, null, React.createElement("div", {
    className: "e-instant-game-info-container ".concat(show ? 'show-game-info' : 'hide')
  }, React.createElement("div", {
    className: "e-instant-game-info",
    itemScope: true,
    itemType: "http://schema.org/Product"
  }, React.createElement("meta", {
    content: name,
    itemProp: "mpn"
  }), React.createElement("meta", {
    content: "Svenska spel",
    itemProp: "brand"
  }), React.createElement(IconButton, {
    className: "e-instant-game-info-icon-close",
    "data-testid": "close-button",
    onClick: onClose
  }, React.createElement(Icon, {
    color: "fc-".concat(isInverted ? 'black' : 'white'),
    icon: "close",
    size: 300
  })), children)));
};
setGlobal('svs.eInstant.shared.info.Wrapper', Wrapper);

 })(window);